module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry-list-item onepx",
    on: {
      "click": _vm.goStore
    }
  }, [_c('div', {
    staticClass: "entry-base-item",
    attrs: {
      "companyId": _vm.item.id
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('ts-image', {
    attrs: {
      "src": _vm.item.productPics[0],
      "width": "132",
      "height": "132",
      "canView": false,
      "disabledHover": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "img-wrapper"
  }, [_c('ts-image', {
    attrs: {
      "src": _vm.item.productPics[1],
      "width": "132",
      "height": "132",
      "canView": false,
      "disabledHover": ""
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-desc"
  }, [_c('div', {
    staticClass: "company-avatar"
  }, [_c('img', {
    directives: [{
      name: "errorImg",
      rawName: "v-errorImg"
    }],
    attrs: {
      "src": _vm.item.companyHeadIcon,
      "width": "31",
      "height": "31"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "desc-title"
  }, [_vm._v(_vm._s(_vm.item.companyName))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-31716c48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePageLists/entry-list-item.vue
// module id = 817
// module chunks = 39